import { render, staticRenderFns } from "./ProcessWaitDialogue.vue?vue&type=template&id=4e20f8f6&"
import script from "./ProcessWaitDialogue.vue?vue&type=script&lang=js&"
export * from "./ProcessWaitDialogue.vue?vue&type=script&lang=js&"
import style0 from "./ProcessWaitDialogue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports